import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import LogoMark from "../components/LogoMark";
import { safePostAuthDestination } from "../utils/navigation";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const nextPath = params.get("next") || "/portal";
  const { login, loading } = useAuth();


  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    try {
      const loggedUser = await login(email, password);
      navigate(safePostAuthDestination(loggedUser, nextPath), { replace: true });
    } catch (err) {
      setError("Login failed. Check your email and password, then try again.");
    }
  }

  return (
    <div className="auth-page-v2 refined-login-page">
      <div className="auth-orb auth-orb--one" />
      <div className="auth-orb auth-orb--two" />

      <header className="auth-header-v2 refined-login-header">
        <Link to="/" className="auth-logo-link"><LogoMark /></Link>
        <div className="auth-header-links">
          <Link to="/">Marketplace</Link>
          <Link to={`/register?next=${encodeURIComponent(nextPath)}`}>Create account</Link>
        </div>
      </header>

      <main className="auth-stage-v2 refined-login-stage">
        <section className="auth-visual-panel refined-login-copy">
          <div className="auth-kicker">SECURE MARKETPLACE ACCESS</div>
          <h1>Access the TAZY marketplace workspace.</h1>
          <p>
            Manage seller verification, product movement, transporter services, wallet workflows,
            subscriptions, AI support and protected communication from one controlled portal.
          </p>

          <div className="login-feature-strip">
            <article>
              <span>01</span>
              <strong>Verified trade</strong>
              <small>Suppliers, buyers and transporters.</small>
            </article>
            <article>
              <span>02</span>
              <strong>Operations control</strong>
              <small>Documents, stock, orders and delivery.</small>
            </article>
            <article>
              <span>03</span>
              <strong>Smart support</strong>
              <small>AI assistance and TAZY CART communication workflows.</small>
            </article>
          </div>
        </section>

        <section className="auth-card-v2 refined-login-card">
          <div className="auth-card-head">
            <img src="/tazy-logo.jpeg" alt="TAZY CART" />
            <span className="api-pill api-pill--ok">Secure access</span>
          </div>

          <h2>Welcome back</h2>
          <p>Sign in with your registered TAZY CART account.</p>

          {error && <div className="error-box">{error}</div>}

          <form onSubmit={handleSubmit} className="auth-form-v2">
            <label>Email address</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="name@example.com" required />

            <label>Password</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Enter password" required />

            <button type="submit" disabled={loading}>{loading ? "Signing in..." : "Sign in"}</button>
          </form>

          <div className="auth-card-footer-v2 auth-help-links">
            <span>New to TAZY CART?</span>
            <Link to={`/register?next=${encodeURIComponent(nextPath)}`}>Create account</Link>
          </div>
        </section>
      </main>

      <footer className="auth-footer-v2 refined-login-footer">
        <span>TAZY CART Marketplace</span>
        <span>Developed by <a href="https://bronixtechnologies.com" target="_blank" rel="noreferrer">Bronix Technologies</a></span>
      </footer>
    </div>
  );
}
